import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { images } from "../shared/assets";
import "./InstagramSection.css";

interface InstagramPost {
  src: string;
  alt: string;
  isVideo?: boolean;
}

interface InstagramSectionProps {
  posts?: InstagramPost[];
  title?: string;
}

const InstagramSection: React.FC<InstagramSectionProps> = ({
  posts,
  title
}) => {
  const { t } = useTranslation();
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);

  const defaultPosts: InstagramPost[] = [
    { src: images.instagram1, alt: "Instagram post 1" },
    { src: images.instagram2, alt: "Instagram post 2" },
    { src: images.instagram3, alt: "Instagram post 3" },
    { src: images.instagram4, alt: "Instagram post 4" }
  ];

  const displayPosts = posts || defaultPosts;

  useEffect(() => {
    // Handle video playback with proper error handling
    videoRefs.current.forEach(video => {
      if (video) {
        video.muted = true;

        // Use a small delay to avoid conflicts with other video elements
        const timer = setTimeout(() => {
          video.play().catch(error => {
            // Silently handle autoplay errors - this is expected behavior
            console.log('Instagram video autoplay prevented:', error);
          });
        }, 100);

        return () => clearTimeout(timer);
      }
    });
  }, [displayPosts]);

  return (
    <section className="instagram-section">
      <div className="instagram-container">
        <h2 className="instagram-title">{title || t('pages/home:instagram.title')}</h2>
        <div className="instagram-feed">
          {displayPosts.map((post, index) => (
            <div key={index} className="instagram-post">
              {post.isVideo ? (
                <video
                  ref={el => { videoRefs.current[index] = el; }}
                  src={post.src}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="auto"
                // Remove autoPlay to control programmatically
                />
              ) : (
                <img src={post.src} alt={post.alt} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;
